import React, { useEffect } from 'react';
import SectionHeading from '../common/SectionHeading';
import { useInView } from "react-intersection-observer";
import { useDispatch, useSelector } from 'react-redux';
import { setActiveSection } from '../../reducers/slices/navSlice';
import { motion } from "framer-motion";
import { fadeIn } from "../../utils/motion";

const About = () => {
    const [ref, inView] = useInView({ threshold: 0.5 });
    const dispatch = useDispatch();
    const { timeOfLastClick } = useSelector((state) => state.activeSec);
    
    useEffect(() => {
        if (inView && Date.now() - timeOfLastClick > 1000) {
            dispatch(setActiveSection("about"));
        }
    }, [inView]);

    return (
        <section ref={ref} id='about' className='scroll-mt-20 py-24 relative overflow-hidden'>
            <SectionHeading text='About Me' />

            <div className='w-[95%] max-w-[800px] mx-auto mt-12 relative'>
                {/* Decorative background element */}
                <div className="absolute -top-10 -right-10 w-40 h-40 bg-purple-500/20 blur-3xl rounded-full"></div>
                <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-blue-500/20 blur-3xl rounded-full"></div>

                <motion.div 
                    initial="hidden"
                    whileInView="show"
                    variants={fadeIn("up", "tween", 0.2, 0.8)}
                    className="glass p-8 md:p-12 rounded-3xl shadow-glass border border-white/10 relative z-10 backdrop-blur-xl"
                >
                    <p className='leading-relaxed tracking-wide text-center text-rich-black-700 text-lg md:text-xl font-medium dark:text-gray-300'>
                        Currently pursuing a <span className="text-accent-primary font-semibold">Master of Computer Applications (MCA)</span>. I am a Full Stack Developer with hands-on experience building scalable web and mobile applications.
                        <br /><br />
                        I specialize in using React.js, Next.js, React Native, Node.js, and AWS cloud services (S3, Lambda, RDS). I have strong expertise in designing RESTful APIs, securing architectures, and integrating complex workflows like Razorpay and Firebase Cloud Messaging. My goal is to deliver end-to-end solutions that are performant, scalable, and beautifully designed.
                    </p>
                </motion.div>
            </div>
        </section>
    );
}

export default About;
